/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import { mountModal } from 'lib/modal.js';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import MediaObject from 'components/MediaObject.jsx';
import Menu from 'components/Menu.jsx';
import MenuButton from 'components/MenuButton.jsx';
import MenuItem from 'components/MenuItem.jsx';
import RelationshipModal from 'user/components/RelationshipModal.jsx';
import Text from 'components/Text.jsx';
import ToastActions from 'actions/ToastActions.js';
import UserAvatar from 'users/components/UserAvatar.jsx';

import './styles/UserParentChildRow.scss';

type MinimalRelatedUser = {
  id: Backbone$Id,
  name: string,
  initials: string,
};

type Props = {
  viewingUserId: ?number,
  relation: 'parent' | 'child',
  relatedUser: MinimalRelatedUser,
  pending?: boolean,
  removeRelation: (parentId: ?Backbone$Id, childId: ?Backbone$Id) => Promise<*>,
  onDelete: () => void,
};

class UserParentChildRow extends React.Component<Props, $FlowFixMeState> {
  state = {};

  confirmRemoveRelation = () => {
    const modal = (
      <ConfirmDialog
        title={`Are you sure you want to remove ${this.props.relatedUser.name} as your ${
          this.props.relation
        }?`}
        onConfirm={this.removeRelation}
      />
    );
    mountModal(modal, this);
  };
  goToProfile = () => {
    const modal = <RelationshipModal userId={this.props.relatedUser.id} />;
    mountModal(modal, this);
  };
  removeRelation = () => {
    const otherId = this.props.relatedUser.id;
    const selfId = this.props.viewingUserId;
    const parentId = this.props.relation === 'child' ? selfId : otherId;
    const childId = this.props.relation === 'child' ? otherId : selfId;

    if (parentId && childId) {
      this.props
        .removeRelation(parentId, childId)
        .then(() => {
          this.props.onDelete();
          ToastActions.showSuccessToast(`A ${this.props.relation} has been removed.`);
        })
        .catch(e => {
          console.error(`Removing ${this.props.relation} relation failed`, e);
          ToastActions.showAPIError(e);
        });
    }
  };
  renderMenu() {
    const removeText = this.props.relation === 'parent' ? 'Remove parent' : 'Remove child';
    return (
      <Menu>
        <MenuItem onClick={this.goToProfile}>
          <Glyph name="avatar" />
          View profile
        </MenuItem>
        <MenuItem onClick={this.confirmRemoveRelation}>
          <Glyph name="close" />
          {removeText}
        </MenuItem>
      </Menu>
    );
  }

  render = () => {
    const { relatedUser, pending } = this.props;
    const textColor = this.props.pending ? 'thunder' : 'pitch';

    return (
      <tr className="UserParentChildRow">
        <td>
          <MediaObject gutter="small" className="UserParentChildRow-name">
            <Link onClick={this.goToProfile}>
              <UserAvatar size="medium" user={relatedUser} />
            </Link>
            <Link onClick={this.goToProfile} className="UserParentChildRow-name-text">
              <Text element="div" color={textColor}>
                {relatedUser.name}
              </Text>
              {pending && (
                <Text element="div" color={textColor}>
                  Pending
                </Text>
              )}
            </Link>
          </MediaObject>
        </td>
        <td>
          <MenuButton
            alignment="right"
            placement="bottom"
            menu={this.renderMenu()}
            size="small"
            level="icon">
            <Glyph name="ellipses" solo />
          </MenuButton>
        </td>
      </tr>
    );
  };
}

const withMutations = graphql(
  gql`
    mutation removeParent($input: RemoveParentRelationshipInput!) {
      removeParentRelationship(input: $input) {
        error {
          message
        }
      }
    }
  `,
  {
    props({ mutate }) {
      return {
        removeRelation(parentId: ?number, childId: ?number) {
          const input = {
            parent_id: parentId,
            child_id: childId,
          };
          return mutate({ variables: { input } });
        },
      };
    },
  }
);

export { UserParentChildRow };
export default withMutations(UserParentChildRow);
